import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PrometheusMetricsData } from "api/observeApi";

export interface SingleGraphMetricsSlice {
  data: PrometheusMetricsData;
  yAxisProps: any;
  summary: string;
  detailsTitle?: string;
  detailsMetric?: string;
  detailsSummary?: string;
  detailsCallback?: string;
  selectedLegends: string[];
}

const initialState: SingleGraphMetricsSlice = {
  data: {
    top_bottom_n_value: 0, // initialize with the appropriate value
    retrieved_at: [],
    avg_rows: [],
    metrics: {},
  },
  yAxisProps: {},
  summary: "",
  selectedLegends: [],
};

export const singleGraphMetricsSlice = createSlice({
  name: "singleGraphMetrics",
  initialState,
  reducers: {
    resetSingleGraphMetricsSlice: () => {
      return initialState;
    },
    setData: (state, action: PayloadAction<PrometheusMetricsData>) => {
      state.data = action.payload;
    },
    setYAxisProps: (state, action: PayloadAction<any>) => {
      state.yAxisProps = action.payload;
    },
    setSelectedLegends: (state, action: PayloadAction<string[]>) => {
      state.selectedLegends = action.payload;
    },
    setSummary: (state, action: PayloadAction<string>) => {
      state.summary = action.payload;
    },
    setDetailsTitle: (state, action: PayloadAction<string | undefined>) => {
      state.detailsTitle = action.payload;
    },
    setDetailsSummary: (state, action: PayloadAction<string | undefined>) => {
      state.detailsSummary = action.payload;
    },
    setDetailsMetric: (state, action: PayloadAction<string | undefined>) => {
      state.detailsMetric = action.payload;
    },
    setDetailsCalback: (state, action: PayloadAction<string | undefined>) => {
      state.detailsCallback = action.payload;
    },
  },
});

export const {
  setData,
  setYAxisProps,
  setSelectedLegends,
  setDetailsTitle,
  setDetailsCalback,
  setDetailsMetric,
  setDetailsSummary,
  setSummary,
} = singleGraphMetricsSlice.actions;

export default singleGraphMetricsSlice.reducer;
